import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import UploadHandler from '../../UploadHandler';
import { fileTypes } from '../../_constants/files';

var Files = function Files(_ref) {
  var fileMap = _ref.fileMap,
      fileState = _ref.fileState,
      onFileUpload = _ref.onFileUpload,
      onFileDelete = _ref.onFileDelete;
  return React.createElement(Fragment, null, React.createElement('label', {
    className: 'mbot-20'
  }, 'Certificate of Incorporation*'), React.createElement('div', {
    className: 'form-group'
  }, React.createElement(UploadHandler, {
    type: fileTypes.CONSTITUTIVE_ACT_COMPANY,
    files: fileMap,
    fileState: fileState,
    onFileUpload: onFileUpload,
    onFileDelete: onFileDelete,
    message: React.createElement('div', {
      className: 'mtop-20'
    }, "Please upload your business\u2019s Certificate of Incorporation or similar registration document from your country\u2019s central registry.")
  })), React.createElement('label', {
    className: 'mbot-20'
  }, 'Balance sheet (most recent year)'), React.createElement('div', {
    className: 'form-group'
  }, React.createElement(UploadHandler, {
    type: fileTypes.LAST_BALANCE,
    files: fileMap,
    fileState: fileState,
    onFileUpload: onFileUpload,
    onFileDelete: onFileDelete
  })), React.createElement('label', {
    className: 'mbot-20'
  }, 'Balance sheet (previous year)'), React.createElement('div', {
    className: 'form-group'
  }, React.createElement(UploadHandler, {
    type: fileTypes.DATE_BALANCE,
    files: fileMap,
    fileState: fileState,
    onFileUpload: onFileUpload,
    onFileDelete: onFileDelete,
    message: React.createElement('div', {
      className: 'mtop-20'
    }, 'Please upload your two most recent end-of-year balance sheets.', React.createElement('br', null), 'NOTE: Balance sheets can only be accepted if signed by the company accountant and a legal representative of the company.')
  })));
};

Files.propTypes = {
  fileMap: PropTypes.object.isRequired,
  fileState: PropTypes.object.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired
};
export default Files;